<template>
  <modal titulo="Gerar imagens de atos digitais" :closeable="false">
    <card title="">
      <card-content>
        <div class="conteudo">
          <h3 v-if="!concluido" class="progresso">Gerando imagens...</h3>
          <h3 v-else class="progresso">Geração concluída</h3>
          <p v-if="!concluido" class="progresso">Essa ação pode levar alguns minutos. Por favor, aguarde.</p>
          <div class="progresso">
            {{ processados }} / {{ total }} matrículas
          </div>

          <div v-if="concluido && total === 0" class="progresso text-muted">
            Nenhuma matrícula com atos digitais a gerar.
          </div>

          <div v-if="concluido && falhas.length" class="alert alert-warning mt-2">
            {{ falhas.length }} matrícula(s) não puderam ser geradas:
            <ul class="mb-0 mt-1">
              <li v-for="(falha, i) in falhas" :key="`falha-${i}`">
                {{ falha.entidade }} — {{ falha.referencia }}: {{ falha.mensagem }}
              </li>
            </ul>
          </div>
        </div>
      </card-content>
    </card>

    <template #footer>
      <button v-if="concluido" type="button" @click.prevent="close()"
        class="btn btn-outline-secondary mr-auto">Fechar</button>
    </template>
  </modal>
</template>

<script>

import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal.vue";

import FrontBusiness from "@/business/FrontBusiness";
import AnexoBusiness from "@/business/AnexoBusiness";

const CONCORRENCIA_MAXIMA = 5;

export default {
  name: "ModalProgressoGerarAtosDigitais",
  components: { CardContent, Card, Modal },
  props: {
    form: Object,
    idProtocolo: String,
  },
  modal: {
    width: 750,
    escapable: false
  },
  data() {
    return {
      concluido: false,
      processados: 0,
      total: 0,
      falhas: [],
    }
  },
  mounted() {
    this.processar();
  },
  methods: {
    close() {
      FrontBusiness.closeModal(true);
    },
    async processar() {
      let unidades = [];
      try {
        unidades = await AnexoBusiness.listarIndicadoresAtosDigitaisProtocolo({
          idProtocolo: this.idProtocolo,
          impressaoCompleta: this.form.impressaoCompleta
        });
      } catch (e) {
        FrontBusiness.showError('', e.exception?.replace("ResponseException: ", "") || e.message);
        this.concluido = true;
        return;
      }

      unidades = (unidades || []).filter(u => u && u.referencia && u.entidade);
      this.total = unidades.length;

      if (this.total === 0) {
        this.concluido = true;
        return;
      }

      await this.processarComConcorrencia(unidades);
      this.concluido = true;
    },
    async processarComConcorrencia(unidades) {
      let proximo = 0;
      const worker = async () => {
        while (proximo < unidades.length) {
          const unidade = unidades[proximo++];
          await this.gerarUnidade(unidade);
        }
      };
      const workers = [];
      for (let i = 0; i < Math.min(CONCORRENCIA_MAXIMA, unidades.length); i++) {
        workers.push(worker());
      }
      await Promise.all(workers);
    },
    async gerarUnidade(unidade) {
      const payload = {
        ...this.form,
        ids: [unidade.referencia],
        entidade: unidade.entidade,
      };
      delete payload.idProtocolo;
      delete payload.id;
      try {
        await AnexoBusiness.gerarDigitalizacaoAtoDigital(payload);
      } catch (e) {
        this.falhas.push({
          referencia: unidade.referencia,
          entidade: unidade.entidade,
          mensagem: e.exception?.replace("ResponseException: ", "") || e.message || 'Erro ao gerar'
        });
      } finally {
        this.processados++;
      }
    },
  }
}
</script>

<style>
.conteudo {
  display: block;
  justify-content: center;
  margin: 0 auto;
}

.progresso {
  display: flex;
  justify-content: center;
  padding: 1rem;
}
</style>
